export default __webpack_public_path__ + "static/media/analyze.7097492f.svg";